import esriConfig from "@arcgis/core/config";
import {getOsBearerToken} from "../../helpers/authHelper";

export function addInterceptors(){

  if(esriConfig.request.interceptors === undefined || 
    esriConfig.request.interceptors.length ===0){
    esriConfig.request.interceptors = [];
    esriConfig.request.interceptors.push({
      urls: "https://api.os.uk/maps/",
       before: (params) => {     
        params.requestOptions.headers = params.requestOptions.headers || {};
        params.requestOptions.headers["Authorization"] = `Bearer ${getOsBearerToken()}`;
      } 
    });
    
    esriConfig.request.interceptors.push({
      urls: "https://api.os.uk/search/places/v1/find/suggest",
      before: (params) => {
        console.log(params);
        params.requestOptions.headers = params.requestOptions.headers || {};
        params.requestOptions.headers["Authorization"] = `Bearer ${getOsBearerToken()}`;
      } 
    });
    
    esriConfig.request.interceptors.push({
      urls: "https://api.os.uk/search/places/v1/find",
      before: (params) => {     
        params.requestOptions.headers = params.requestOptions.headers || {};
        params.requestOptions.headers["Authorization"] = `Bearer ${getOsBearerToken()}`;
      } 
    });

    esriConfig.request.interceptors.push({
      urls: "https://api.os.uk/search/names/v1/find",
      before: (params) => {     
        params.requestOptions.headers = params.requestOptions.headers || {};
        params.requestOptions.headers["Authorization"] = `Bearer ${getOsBearerToken()}`;
      } 
    });
    esriConfig.request.interceptors.push({
      urls: "https://api.os.uk/search/names/v1/find/suggest",
      before: (params) => {
        console.log(params);
        params.requestOptions.headers = params.requestOptions.headers || {};
        params.requestOptions.headers["Authorization"] = `Bearer ${getOsBearerToken()}`;
      } 
    });
  }
  
}